// export const currentEnv = process?.env?.REACT_APP_ENV as 'prod' | 'stage';
// export const BASE_API = process.env.REACT_APP_BASE_URL;

import EventBus from './common/EventBus';

const BASE_API_MAP = {
  prod: 'https://api.idukki.io',
  stage: 'https://dev-api.idukki.io',
};

const NEW_API_MAP = {
  prod: 'https://widget-api.idukki.io',
  stage: 'https://widget-staging-api.idukki.io',
};

export const CLICK_EVENTS = {
  PDP_REDIRECT: 'PDP_REDIRECT',
  VIDEO_WATCH: 'VIDEO_WATCH',
  IMG_CLICK: 'click',
  ADD_TO_CART: 'ADD_TO_CART',
};

export const SOURCE_TYPES = {
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
};

let staging = false;
EventBus.getInstance().addListener('isStaging', (e) => {
  staging = e;
});
// do we really need event for this...
// if needed then sequence is wrong first add listener and then fire
if (import.meta.env.VITE_APP_ENV === 'stage') {
  staging = true;
}
export const API_BASE_URL = () => BASE_API_MAP[staging ? 'stage' : 'prod'];
export const NEW_API_BASE_URL = () => NEW_API_MAP[staging ? 'stage' : 'prod'];

export const grid = 'grid';
export const carousel = 'carousel';
export const collage = 'collage';
export const feed = 'feed';
export const wall1 = 'wall1';
export const wall2 = 'wall2';
export const masonry = 'masonry';
export const carousel3D = 'carousel3d';
export const expandableImage = 'expandable';
export const testimonial1 = 'testimonial1';
export const testimonial2 = 'testimonial2';
export const testimonial3 = 'testimonial3';
export const premium1 = 'premium1';
export const premium2 = 'premium2';
export const stories = 'stories';
export const story = 'story';
export const badge = 'badge';
export const frame = 'frame';
export const vertical = 'vertical';
export const specialGrid = 'specialGrid';
export const inspiration = 'inspiration';

export const maxContainerWidth = '1000px';

export const googleAPI = 'AIzaSyCzX_zfLv45CojDrbJN6LpuDylJhN5VY44';

export const emptyImage = 'https://idukki-cdn.com/empty.svg';
export const halfStarImage = 'https://idukki-cdn.com/halfStar.svg';
export const Idukki_shortImage = 'https://idukki-cdn.com/Idukki-Short.png';
export const loadingImage = 'https://idukki-cdn.com/loading.svg';
export const notfoundImage = 'https://idukki-cdn.com/not-found.svg';
export const transparentLoaderImage = 'https://idukki-cdn.com/transparentLoder.gif';
export const uploadImage = 'https://idukki-cdn.com/upload.png';

export const PAGE_TYPES = {
  homepage: 'homepage',
  product: 'pdp',
  category: 'category',
};

export const ACTION_TYPES = {
  blank: '',
  reTarget: 'IDK_RETARGET',
  idk3p: 'IDK_3P',
};

export const SWIPE_INDICATOR_KEY = 'idukki_has_swiped';
